/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <v-layout row wrap>
      <Toolbar dense class="mt-1 mr-1 ml-1">
        <div class="d-flex">
          <div class="mr-4 subheading">{{ $t('MFM List') }}</div>
          <div class="body-1">
            [ {{ selectedBlock.text }} ]
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="body-1">
          {{ show_date }}
        </div>
      </Toolbar>
      <v-flex xs12 sm12 md4 lg4 xl4>
        <Cards :plantId="plantId" :blockId="selectedBlock ? selectedBlock.id : ''"
          :date="activeFilter.Date.from" v-on:initalGraph="loadCardData"
          v-on:onClickCard="onCardClick" :key="reloadComponent"></Cards>
      </v-flex>
      <v-flex xs12 sm12 md8 lg8 xl8>
        <GlobalGraph :key="graphReload" class="graph" v-if="series.length" :series="computedSeries" :xAxisData="xAxis" :yAxis="yAxis" :theme="theme" :loading="loading" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  mapGettersMixin,
  filterMixin
} from '@/util/mixin/index'
import list from '@/services/mfm.js'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import GlobalGraph from '@/components/common/GlobalGraph'
import Cards from '@/components/mfm/MfmCard'
const moment = require('moment')
const momentTz = require('moment-timezone')

export default {
  mixins: [ mapGettersMixin, filterMixin ],
  components: {
    Cards,
    GlobalGraph
  },
  data() {
    return {
      enableWatch: false,
      mfmListLength: 0,
      graphData: [],
      reloadComponent: 0,
      graphReload: 0,
      plantId: 0,
      loading: false,
      subscriptionMessage: 'This feature is not applicable for your plant.',
      series: [],
      xAxis: [],
      yAxis: [{ type: 'value' }],
      tempData: ''
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getGeneralState', 'getActivePlantInfo', 'getFilterOptions']),
    activeFilter() {
      return this.getGeneralState('activeFilterOption')
    },
    // TODO: Remove this when the time of refactoring API
    show_date() {
      return moment(this.activeFilter.Date.from).format('YYYY/M/D')
    },
    selectedBlock() {
      return this.activeFilter.blockId ? this.activeFilter.blockId : this.activeParam['blockId']
    },
    currentLanguage() {
      return this.getGeneralState('language')
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series)
      return cloneSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    }
  },
  async created() {
    this.initialStates()
    await this.initialConfigList()
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT'
    ]),
    ...mapActions(['fetchBlockList']),
    async initialConfigList() {
      let blockListRes = await this.getMfmBlockList()
      this.setDynamicFilterConfig([{
        from: momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD'),
        to: momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
      }, blockListRes.data.message[0]])
    },
    initialStates() {
      this.enableWatch = false
      this.plantId = this.getSelectedPlantId
      this.tempData = ''
    },
    async callAllApi(val) {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      await this.getGraphData(val)
    },
    onCardClick(val) {
      this.tempData = val
      this.callAllApi(val)
    },
    async loadCardData(value) {
      this.tempData = value[0]
      this.$set(this.graphData, 0, value)
      await this.setIntervalWithoutDelay(() => this.callAllApi(this.tempData))
    },
    async getGraphData(value) {
      this.loading = true
      let response = await list.getMfmData({
        plantId: this.plantId,
        query: `${value.block_id}-${value.inverter_room}-${value.feeder_id}`,
        date: this.activeFilter.Date.from
      })
      let data = response.data.message
      this.enableWatch = true
      this.series = [...data.graph]
      this.xAxis = [...data.xAxis]
      this.loading = false
    },
    getMfmBlockList() {
      return this.fetchBlockList([this.getSelectedPlantId, 'mfm'])
    }
  },
  watch: {
    async getSelectedPlantId() {
      this.initialStates()
      await this.initialConfigList()
      this.reloadComponent += 1
    },
    isReload() {
      if (this.isReload) {
        this.reloadComponent += 1
      }
    },
    'activeFilter.Date.from'(date) {
      let currentDate = momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
      if (this.enableWatch) {
        this.reloadComponent += 1
        if (moment(date).diff(currentDate, 'days') > 0) {
          let payload = {
            icon: 'error',
            message: 'Please enter a valid date to view dashboard'
          }
          this.SET_SNACKBAR_CONTENT(payload)
          this.SET_SHOW_SNACKBAR(true)
        } else {
          if (this.tempData) {
            this.reloadComponent += 1
          }
        }
      }
    },
    'selectedBlock.id'() {
      if (this.enableWatch) {
        this.reloadComponent += 1
      }
    },
    currentLanguage() {
      graphReload += 1
    }
  }
}
</script>
<style scoped>
  .graph {
    width: 100%;
    height: calc(100vh - 296px)
  }
</style>
